<template>
  <div class="popup-content">
    <div class="popup-header">
      <h4 class="title">Выберите объект</h4>
    </div>
    <div class="select-layer-content">
      <!-- <button @click="qwe">Показать слои</button> -->
      <div class="layers-list">
        <div class="layer-item" v-for="(layer, index) in arrFeatures" :key="index" @click="selectLayer(layer)">
          <span>{{ layer.properties.reg_num }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['arrFeatures', 'selectLayerProps'],
  methods: {
    /* qwe () {
      console.log(this.arrFeatures)
    }, */
    closePopup () {
      this.$emit('closePopup')
    },
    selectLayer (layer) {
      this.selectLayerProps(layer)
      this.closePopup()
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 35px 50px;
  h4 {
    margin-bottom: 15px;
  }
}
.layer-item {
  cursor: pointer;
  margin-top: 15px;
  font-weight: 600;
  transition: .3s;
  &:hover {
    color: #4E53E7
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupSelectLayerVue.vue